<template>
  <div>
    <section class="page-title text-center">
      <div class="container">
        <div class="content-box">
          <h1>{{ $t("Appointment") }} {{ $getByLang(name) }}</h1>
        </div>
      </div>
    </section>

    <!--SECTION START-->
    <section
      style="background-color: white; padding-top: 36px; padding-bottom: 150px"
    >
      <div class="mr-3 ml-3">
        <b-tabs content-class="mt-3" v-model="tabIndex" align="center">
          <b-tab :title="$t('Calendar')" active>
            <div class="row">
              <div class="col-md-3">
                <b-calendar
                  v-model="day"
                  start-weekday="1"
                  :min="minDate"
                  block
                ></b-calendar>
                <br />
                <!-- <b-list-group class="no-in-phone">
                  <b-list-group-item v-for="option in userList" :key="option.id" :value="option.id">
                    <router-link :to="'/user/' + option.id" class="asa">
                      <img style="height: 50px; width: 50px; padding-bottom: 5px" :src="$baseUploadURL + option.image"
                        alt="" />
                      {{ option.fullName }}
                    </router-link>
                  </b-list-group-item>
                </b-list-group> -->
              </div>
              <div class="col-md-9">
                <div style="text-align: center;" v-if="!loading">
                  <img
                    src="../assets/l.gif"
                    style="border-radius: 20px;"
                    alt=""
                  />
                </div>
                <component
                  v-show="loading"
                  :is="fullCalendarComponent"
                  v-if="isFullCalendarLoaded"
                  :options="calendarOptions"
                  ref="calendar2"
                />
              </div>
              <div class="col-md-12">
                <b-button
                  block
                  variant="danger"
                  :disabled="bodyArray.length == 0"
                  @click="tabIndex++"
                  style="background-color: #f26838; color: white"
                  >{{ $t("Next") }}</b-button
                >
              </div>
            </div>
          </b-tab>
          <b-tab
            :title="$t('Appointment') + ' ' + $t('info')"
            :disabled="bodyArray.length == 0"
          >
            <div class="wwwppp">
              <!-- عرض تفاصيل الحجوزات المختارة -->
              <div
                class="selected-appointments mb-4"
                v-if="selectedAppointmentsDetails.length > 0"
              >
                <h4 class="mb-3">{{ $t("Selected Appointments") }}</h4>

                <!-- تصميم الجدول للويب -->
                <div class="desktop-view d-none d-md-block">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover">
                      <thead class="table-dark">
                        <tr>
                          <th>{{ $t("Appointment") }}</th>

                          <th>{{ $t("Massage Type") }}</th>
                          <th>{{ $t("Date") }}</th>
                          <th>{{ $t("Time") }}</th>
                          <th>{{ $t("Price") }}</th>
                          <th>{{ $t("Therapist") }}</th>
                          <th>{{ $t("Actions") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(appointment,
                          index) in selectedAppointmentsDetails"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ appointment.massageName }}</td>
                          <td>{{ formatDate(appointment.start) }}</td>
                          <td>
                            {{ formatTime(appointment.start) }} -
                            {{ formatTime(appointment.end) }}
                          </td>
                          <td>{{ appointment.price }}€</td>

                          <td>{{ appointment.therapistName }}</td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-danger"
                              @click="removeAppointment(index)"
                            >
                              {{ $t("Remove") }}
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- تصميم البطاقات للموبايل -->
                <div class="mobile-view d-block d-md-none">
                  <div class="row">
                    <div
                      class="col-12"
                      v-for="(appointment,
                      index) in selectedAppointmentsDetails"
                      :key="index"
                    >
                      <div class="card mb-3">
                        <div class="card-body">
                          <h6 class="card-title">
                            {{ $t("Appointment") }} {{ index + 1 }}
                          </h6>

                          <p class="card-text">
                            <strong>{{ $t("Massage Type") }}:</strong>
                            {{ appointment.massageName }}
                          </p>

                          <p class="card-text">
                            <strong>{{ $t("Price") }}:</strong>
                            {{ appointment.price }}€
                          </p>
                          <p class="card-text">
                            <strong>{{ $t("Date") }}:</strong>
                            {{ formatDate(appointment.start) }}
                          </p>
                          <p class="card-text">
                            <strong>{{ $t("Time") }}:</strong>
                            {{ formatTime(appointment.start) }} -
                            {{ formatTime(appointment.end) }}
                          </p>
                          <p class="card-text">
                            <strong>{{ $t("Therapist") }}:</strong>
                            {{ appointment.therapistName }}
                          </p>
                          <div class="text-right mt-2">
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-danger"
                              @click="removeAppointment(index)"
                            >
                              {{ $t("Remove") }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <form method="post" class="row">
                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="sexType" class="form-label">
                      {{ $t("Type") }}
                    </label>

                    <b-form-select v-model="body.sexType" class="mb-3">
                      <b-form-select-option value="MR">{{
                        $t("MR")
                      }}</b-form-select-option>
                      <b-form-select-option value="MRS">{{
                        $t("MRS")
                      }}</b-form-select-option>
                    </b-form-select>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label for="fname" class="form-label">
                      {{ $t("First Name") }}</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="fname"
                      v-model="body.fname"
                    />
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label for="lname" class="form-label">{{
                      $t("Last Name")
                    }}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="lname"
                      v-model="body.lname"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="phone" class="form-label">{{
                      $t("Phone")
                    }}</label>

                    <vue-tel-input
                      v-model.trim="body.phone"
                      v-bind="{
                        mode: 'international'
                      }"
                      :allCountries="allCountries"
                    ></vue-tel-input>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class=" mb-3">
                    <label for="paymentMethod">{{ $t("Pay Type") }}</label>
                    <select
                      class="custom-select"
                      id="paymentMethod"
                      name="paymentMethod"
                      v-model="body.paymentMethod"
                    >
                      <option value="cash">{{ $t("Cash") }}</option>
                      <!-- <option value="online">{{ $t("Online") }}</option> -->
                      <option value="hotel">{{ $t("hotel guests") }}</option>
                      <option value="Gift">{{ $t("Use Gift") }}</option>
                      <option value="Package">{{ $t("Use Package") }}</option>
                    </select>
                  </div>
                </div>

                <!-- <div class="col-md-6">

                </div> -->

                <div class="col-md-12" v-if="body.paymentMethod == 'hotel'">
                  <div class="mb-3">
                    <label for="hotel" class="form-label">
                      {{ $t("hotel guest") }}
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      id="hotel"
                      v-model.number="body.hotel"
                    />
                  </div>
                </div>
                <div class="col-md-12" v-if="body.paymentMethod == 'Gift'">
                  <div class="mb-3">
                    <label for="giftsId" class="form-label">{{
                      $t("Gift Card Number")
                    }}</label>
                    <input
                      type="number"
                      class="form-control"
                      id="giftsId"
                      v-model.number="body.giftsId"
                    />
                    <!-- <select
                      class="custom-select"
                      id="giftsId"
                      name="giftsId"
                      v-model.number="body.giftsId"
                    >
                      <option v-for="itm of giftsList" :value="itm.id">
                        ( {{ $codePadding(itm.id) }} ) {{ itm.price }} € from
                        {{ itm.usersId.sexType }} /
                        {{ itm.usersId.fname }}
                        {{ itm.usersId.lname }}
                      </option>
                    </select> -->
                  </div>
                </div>
                <div class="col-md-12" v-if="body.paymentMethod == 'Package'">
                  <div class="mb-3">
                    <label for="packagesUsersId" class="form-label">{{
                      $t("Package")
                    }}</label>
                    <select
                      class="custom-select"
                      id="packagesUsersId"
                      name="packagesUsersId"
                      v-model.number="body.packagesUsersId"
                    >
                      <option v-for="itm of packagesUsersList" :value="itm.id">
                        {{ $getByLang(itm.packagesId.name) }} -
                        {{ $getByLang(itm.packagesPricesId.name) }} ({{
                          itm.packagesPricesId.price
                        }}
                        €)
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="email" class="form-label">{{
                      $t("Email address")
                    }}</label>
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      v-model="body.email"
                      placeholder="name@example.com"
                    />
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="mb-3">
                    <label for="address" class="form-label">
                      {{ $t("AddressHome") }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="address"
                      v-model="body.address"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="zip" class="form-label">
                      {{ $t("zip") }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="zip"
                      v-model="body.zip"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="city" class="form-label">
                      {{ $t("city") }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      v-model="body.city"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="country" class="form-label">
                      {{ $t("country") }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="country"
                      v-model="body.country"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="note" class="form-label">{{
                      $t("note")
                    }}</label>
                    <textarea
                      class="form-control"
                      v-model="body.note"
                      id="note"
                      rows="3"
                    ></textarea>
                  </div>
                  <b-button
                    block
                    variant="danger"
                    :disabled="
                      !this.body.fname &&
                        !this.body.lname &&
                        !this.body.phone &&
                        // !this.body.email &&
                        !this.body.date &&
                        !this.body.time
                    "
                    @click="save"
                    style="background-color: #f26838; color: white"
                    >{{ $t("Confirm") }}</b-button
                  >
                </div>
              </form>
            </div>
          </b-tab>
        </b-tabs>

        <b-modal v-model="modalShow" id="modal-prevent-closing">
          <div class="mb-3">
            <label for="personsNumber" class="form-label">
              {{ $t("Massage Type") }}
            </label>
            <!-- <b-form-select v-model="newAdd.massageId" class="mb-3">
              <b-form-select-option-group
                v-for="item of newMassageList"
                :key="item.id"
                :label="$getByLang(item.name)"
              >
                <b-form-select-option
                  v-for="itm of item.list"
                  :key="itm.id"
                  :value="itm.id"
                  >{{ $getByLang(itm.name) }}</b-form-select-option
                >
              </b-form-select-option-group>
            </b-form-select> -->

            <CascadeSelect
              class="mb-3"
              v-model="newAdd.massageId"
              :options="newMassageList"
              optionLabel="name"
              optionValue="id"
              optionGroupLabel="name"
              :optionGroupChildren="['list']"
              style="width: 100%"
            >
              <template #option="slotProps">
                <div class="country-item">
                  <img
                    :src="$baseUploadURL + slotProps.option.image"
                    v-if="slotProps.option.image"
                    style="width: 40px; height: 30px;border-radius: 5px;margin-right: 14px;"
                  />

                  <span>{{ slotProps.option.name }}</span>
                </div>
              </template>
            </CascadeSelect>
          </div>

          <div class="mb-3">
            <label for="personsNumber" class="form-label">
              {{ $t("Price Plan") }}
            </label>
            <Dropdown
              v-model="newAdd.pricesId"
              class="mb-3"
              style="width: 100%"
              :options="pricesList"
              optionValue="id"
            >
              <template #value="slotProps">
                <div
                  class="country-item country-item-value"
                  v-if="slotProps.value && pricesList.length > 0"
                >
                  {{
                    $getByLang(
                      pricesList.find(
                        el => Number(el.id) == Number(slotProps.value)
                      ).name
                    )
                  }}

                  {{
                    pricesList.find(
                      el => Number(el.id) == Number(slotProps.value)
                    ).minutes
                  }}
                  {{ $t("minutes") }} =
                  {{
                    pricesList.find(
                      el => Number(el.id) == Number(slotProps.value)
                    ).price
                  }}€
                </div>
              </template>
              <template #option="slotProps">
                <div class="country-item">
                  {{ $getByLang(slotProps.option.name) }}

                  {{ slotProps.option.minutes }} {{ $t("minutes") }} =
                  {{ slotProps.option.price }}€
                </div>
              </template>
            </Dropdown>

            <!-- <b-form-select v-model="newAdd.pricesId" class="mb-3">
              <b-form-select-option
                v-for="item of pricesList"
                :key="item.id"
                :value="item.id"
              >
                {{ $getByLang(item.name) }}

                {{ item.minutes }} {{ $t("minutes") }} =
                {{ item.price }}€</b-form-select-option
              >
            </b-form-select> -->
          </div>

          <template #modal-footer>
            <div class="w-100 row">
              <div class="col-6">
                <b-button
                  variant="secondary"
                  size="sm"
                  block
                  @click="addNewObject"
                >
                  {{ $t("Another Reservation") }}
                </b-button>
              </div>

              <div class="col-6 ">
                <b-button
                  variant="primary"
                  size="sm"
                  block
                  @click="nextAddToList"
                  class="custom-actions-button"
                >
                  {{ $t("Next") }}
                </b-button>
              </div>
            </div>
          </template>
        </b-modal>
      </div>
    </section>
  </div>
</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite

import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import moment from "moment";

import axios from "axios";
import querystring from "querystring";

import { v4 as uuidv4 } from "uuid";

export default {
  components: {},
  data() {
    return {
      minDate: new Date(),
      tabIndex: 0,
      modalShow: false,
      allCountries: [
        ["Austria (Österreich)", "at", "43"],
        ["Germany (Deutschland)", "de", "49"],
        ["Switzerland (Schweiz)", "ch", "41"],
        ["Liechtenstein", "li", "423"]
      ].map(([name, iso2, dialCode]) => ({
        name,
        iso2: iso2.toUpperCase(),
        dialCode
      })),
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
          resourceTimeGridPlugin
        ],
        headerToolbar: {
          left: "prev,next",
          center: "title",
          right: ""
        },
        allDaySlot: false, // Hide all-day row
        initialView: "resourceTimeGridDay",
        initialDate: new Date(),
        slotDuration: "00:15:00",
        slotLabelInterval: 15,
        slotMinutes: 15,
        slotLabelFormat: { hour: "numeric", minute: "2-digit", hour12: false },

        businessHours: true,
        slotMinTime: "09:00",
        slotMaxTime: "22:00",
        selectMirror: true,

        events: [],
        schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
        resources: [],
        selectable: true,
        select: this.handleDateSelect,
        selectLongPressDelay: 150,
        eventClick: this.handleEventClick,
        validRange: {
          start: new Date() // Locks old dates
        },
        resourceLabelContent: arg => {
          let image = document.createElement("img");
          image.src = arg.resource.extendedProps.image;
          image.style.width = "50px"; // Set the width of the image
          image.style.height = "50px"; // Set the height of the image
          image.style.marginRight = "10px";

          let label = document.createElement("a");
          label.style.fontWeight = "700";
          label.href = "/user/" + arg.resource.id;
          label.appendChild(image);
          label.appendChild(document.createTextNode(arg.resource.title));

          return { html: label.outerHTML };
        }
      },

      body: {
        usersId: null,
        email: null,
        phone: null,
        sexType: null,
        fname: null,
        lname: null,
        address: null,
        zip: null,
        city: null,
        country: null,
        paymentMethod: "cash"
      },
      newAdd: {
        adminsId: null,
        massageId: null,
        pricesId: null,
        therapistName: null
      },
      bodyArray: [],
      selectedAppointmentsDetails: [], // متغير جديد لحفظ تفاصيل الجلسات المختارة
      userList: [],
      massageList: [],
      newMassageList: [],

      day: null,
      name: null,
      pricesList: [],
      appointmentsList: [],
      packagesUsersList: [],
      giftsList: [],
      stopList: [],
      loading: true
    };
  },

  methods: {
    retObjVal(user, date) {
      let lock = false;

      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      const dddd123 = new Date(date);
      const d = new Date(dddd123);
      const dayName = days[d.getDay()];

      if (user[dayName] == false) {
        lock = true;
      }

      if (user.holdTo && user.holdFrom) {
        var d1 = new Date(dddd123);
        var d2 = new Date(user.holdTo);
        var d3 = new Date(user.holdFrom);
        if (d1.getTime() <= d2.getTime() && d1.getTime() >= d3.getTime()) {
          lock = true;
        }
      }

      return lock;
    },
    async onTime() {
      const { data } = await this.$http.get(`appointments?date=${this.day}`);
      const { stopes } = await this.$http.get(`stoptimes?date=${this.day}`);
      if (
        (data &&
          data.data &&
          this.appointmentsList.length != data.data.length) ||
        (stopes && stopes.data && stopes.data.length != this.stopList.length)
      ) {
        this.getData();
      }
    },
    getData() {
      this.loading = false;
      this.calendarOptions.resources = [];
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      const d = new Date(this.day);
      const dayName = days[d.getDay()];

      for (const item of this.userList) {
        if (this.retObjVal(item, d) == false) {
          this.calendarOptions.resources.push({
            id: item.id,
            title: item.fullName,
            image: this.$baseUploadURL + item.image,
            businessHours: {
              startTime: item[dayName + "Start"], // a start time (10am in this example)
              endTime: item[dayName + "End"], // an end time (6pm in this example)
              daysOfWeek: [0, 1, 2, 3, 4, 5, 6] // Mon,Wed,Fri
            }
          });
        }
      }

      this.$http
        .post(`appointments/gatByDay?date=${this.day}`)
        .then(async res => {
          this.calendarOptions.events = [];
          const list = await res.data.data;
          this.appointmentsList = list;
          for (const item of list) {
            // Only show event if the employee is a visible resource (works that day)
            const isResourceVisible = this.calendarOptions.resources.some(
              r => Number(r.id) === Number(item.adminsId?.id)
            );
            if (isResourceVisible) {
              this.calendarOptions.events.push({
                id: item.id,
                title: "Ausgebucht",
                start: new Date(item.start),
                end: new Date(item.end),
                resourceId: Number(item.adminsId?.id),
                allDay: false
                // backgroundColor: item.massageId?.color,
              });
            }
          }
          const stopes = await this.$http.get(`stoptimes?date=${this.day}`);
          if (stopes && stopes.data && stopes.data.data) {
            const stopList = stopes.data.data;
            this.stopList = stopes.data.data;
            for (const item of stopList) {
              // Only show stop time if the employee is a visible resource (works that day)
              const isResourceVisible = this.calendarOptions.resources.some(
                r => Number(r.id) === Number(item.adminsId?.id)
              );
              if (isResourceVisible) {
                this.calendarOptions.events.push({
                  id: "stop_" + item.id,
                  title: "Ausgebucht",
                  start: new Date(item.start),
                  end: new Date(item.end),
                  resourceId: Number(item.adminsId?.id),
                  allDay: false
                  // backgroundColor: "#" + item.color,
                });
              }
            }
          }
          this.loading = true;
          let calendarApi = this.$refs.calendar2.getApi();
          calendarApi.changeView("resourceTimeGridDay", d);
        });
    },
    handleEventClick(clickInfo) {
      if (!clickInfo.event.id) {
        if (
          confirm(
            `Are you sure you want to delete the event '${clickInfo.event.title}'`
          )
        ) {
          // this.body.time = null;
        }
      }
    },
    checkIfTimeAvailable(start, userId) {
      let lock = false;

      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      const d = new Date(start);
      const dayName = days[d.getDay()];
      const user = this.userList.find(u => u.id == userId);

      // Check if user is on vacation or not working this day
      if (this.retObjVal(user, start)) {
        this.$swal.fire({
          icon: "error",
          title: this.$t("Error"),
          text: user.fullName + " is not available",
          showConfirmButton: false,
          timer: 1500
        });
        return true;
      }

      const day = moment(start).format("YYYY-MM-DD");

      const startInDay = moment(
        day + " " + user[dayName + "Start"],
        "YYYY-MM-DD HH:mm"
      ).format();

      const endInDay = moment(
        day + " " + user[dayName + "End"],
        "YYYY-MM-DD HH:mm"
      ).format();

      // Check if the time is within working hours
      if (startInDay && endInDay) {
        const d1 = new Date(d);
        const d2 = new Date(startInDay);
        const d3 = new Date(endInDay);

        if (d1.getTime() >= d2.getTime() && d1.getTime() <= d3.getTime()) {
          lock = false;
        } else {
          lock = true;
        }
      }

      // Check for conflicts with existing appointments in bodyArray
      for (const item of this.bodyArray) {
        if (item.adminsId == userId) {
          const d1 = new Date(d);
          const d2 = new Date(item.start);
          const d3 = new Date(item.end);

          // Check if the start time conflicts with any existing appointment
          if (d1.getTime() >= d2.getTime() && d1.getTime() < d3.getTime()) {
            lock = true;
          }
        }
      }

      // Check for conflicts with existing appointments in appointmentsList
      for (const item of this.appointmentsList) {
        if (
          startInDay &&
          endInDay &&
          item.adminsId &&
          item.adminsId.id == userId
        ) {
          const d1 = new Date(d);
          const d2 = new Date(item.start);
          const d3 = new Date(item.end);

          // Check if the start time conflicts with any existing appointment
          if (d1.getTime() >= d2.getTime() && d1.getTime() < d3.getTime()) {
            lock = true;
          }
        }
      }

      // Check for conflicts with stop times
      for (const item of this.stopList) {
        if (
          startInDay &&
          endInDay &&
          item.adminsId &&
          item.adminsId.id == userId
        ) {
          const d1 = new Date(d);
          const d2 = new Date(item.start);
          const d3 = new Date(item.end);

          // Check if the start time conflicts with any stop time
          if (d1.getTime() >= d2.getTime() && d1.getTime() < d3.getTime()) {
            lock = true;
          }
        }
      }

      if (lock) {
        this.$swal.fire({
          icon: "error",
          title: this.$t("Error"),
          text: user.fullName + " is not available",
          showConfirmButton: false,
          timer: 1500
        });
      }
      return lock;
    },
    checkIfTimeAvailableEnd(end, userId) {
      let lock = false;

      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      const d = new Date(end);
      const dayName = days[d.getDay()];
      const user = this.userList.find(u => u.id == userId);

      const day = moment(end).format("YYYY-MM-DD");

      const startInDay = moment(
        day + " " + user[dayName + "Start"],
        "YYYY-MM-DD HH:mm"
      ).format();

      const endInDay = moment(
        day + " " + user[dayName + "End"],
        "YYYY-MM-DD HH:mm"
      ).format();

      // Check if the end time is within working hours
      if (startInDay && endInDay) {
        const d1 = new Date(d);
        const d2 = new Date(startInDay);
        const d3 = new Date(endInDay);

        if (d1.getTime() > d2.getTime() && d1.getTime() <= d3.getTime()) {
          lock = false;
        } else {
          lock = true;
        }
      }

      // Check for conflicts with existing appointments in bodyArray
      for (const item of this.bodyArray) {
        if (item.adminsId == userId) {
          const d1 = new Date(d);
          const d2 = new Date(item.start);
          const d3 = new Date(item.end);

          // Check if the end time conflicts with any existing appointment
          if (d1.getTime() > d2.getTime() && d1.getTime() <= d3.getTime()) {
            lock = true;
          }
        }
      }

      // Check for conflicts with existing appointments in appointmentsList
      for (const item of this.appointmentsList) {
        if (
          startInDay &&
          endInDay &&
          item.adminsId &&
          item.adminsId.id == userId
        ) {
          const d1 = new Date(d);
          const d2 = new Date(item.start);
          const d3 = new Date(item.end);

          // Check if the end time conflicts with any existing appointment
          if (d1.getTime() > d2.getTime() && d1.getTime() <= d3.getTime()) {
            lock = true;
          }
        }
      }

      // Check for conflicts with stop times
      for (const item of this.stopList) {
        if (
          startInDay &&
          endInDay &&
          item.adminsId &&
          item.adminsId.id == userId
        ) {
          const d1 = new Date(d);
          const d2 = new Date(item.start);
          const d3 = new Date(item.end);

          // Check if the end time conflicts with any stop time
          if (d1.getTime() > d2.getTime() && d1.getTime() <= d3.getTime()) {
            lock = true;
          }
        }
      }

      if (lock) {
        this.$swal.fire({
          icon: "error",
          title: this.$t("Error"),
          text: user.fullName + " is not available",
          showConfirmButton: false,
          timer: 1500
        });
      }
      return lock;
    },
    checkIfTimeRangeAvailable(start, end, userId) {
      let lock = false;

      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      const startDate = new Date(start);
      const endDate = new Date(end);
      const dayName = days[startDate.getDay()];
      const user = this.userList.find(u => u.id == userId);

      // Check if user is on vacation or not working this day
      if (this.retObjVal(user, start)) {
        this.$swal.fire({
          icon: "error",
          title: this.$t("Error"),
          text: user.fullName + " is not available for this time range",
          showConfirmButton: false,
          timer: 1500
        });
        return true;
      }

      const day = moment(start).format("YYYY-MM-DD");

      const startInDay = moment(
        day + " " + user[dayName + "Start"],
        "YYYY-MM-DD HH:mm"
      ).format();

      const endInDay = moment(
        day + " " + user[dayName + "End"],
        "YYYY-MM-DD HH:mm"
      ).format();

      // Check if the time range is within working hours
      if (startInDay && endInDay) {
        const d1 = new Date(startDate);
        const d2 = new Date(startInDay);
        const d3 = new Date(endInDay);

        if (d1.getTime() < d2.getTime() || d1.getTime() >= d3.getTime()) {
          lock = true;
        }

        const e1 = new Date(endDate);
        if (e1.getTime() <= d2.getTime() || e1.getTime() > d3.getTime()) {
          lock = true;
        }
      }

      // Check for conflicts with existing appointments in bodyArray
      for (const item of this.bodyArray) {
        if (item.adminsId == userId) {
          const itemStart = new Date(item.start);
          const itemEnd = new Date(item.end);

          // Check if the time ranges overlap
          if (
            startDate.getTime() < itemEnd.getTime() &&
            endDate.getTime() > itemStart.getTime()
          ) {
            lock = true;
          }
        }
      }

      // Check for conflicts with existing appointments in appointmentsList
      for (const item of this.appointmentsList) {
        if (
          startInDay &&
          endInDay &&
          item.adminsId &&
          item.adminsId.id == userId
        ) {
          const itemStart = new Date(item.start);
          const itemEnd = new Date(item.end);

          // Check if the time ranges overlap
          if (
            startDate.getTime() < itemEnd.getTime() &&
            endDate.getTime() > itemStart.getTime()
          ) {
            lock = true;
          }
        }
      }

      // Check for conflicts with stop times
      for (const item of this.stopList) {
        if (
          startInDay &&
          endInDay &&
          item.adminsId &&
          item.adminsId.id == userId
        ) {
          const itemStart = new Date(item.start);
          const itemEnd = new Date(item.end);

          // Check if the time ranges overlap
          if (
            startDate.getTime() < itemEnd.getTime() &&
            endDate.getTime() > itemStart.getTime()
          ) {
            lock = true;
          }
        }
      }

      if (lock) {
        this.$swal.fire({
          icon: "error",
          title: this.$t("Error"),
          text: user.fullName + " is not available for this time range",
          showConfirmButton: false,
          timer: 1500
        });
      }
      return lock;
    },
    isDateTimeInPast(dateTime) {
      const inputDateTime = new Date(dateTime);
      const currentDateTime = new Date();

      return inputDateTime < currentDateTime;
    },
    handleDateSelect(selectInfo) {
      this.newAdd.adminsId = selectInfo.resource.id;
      this.newAdd.therapistName = selectInfo.resource.title; // حفظ اسم المسير من selectInfo

      if (
        this.checkIfTimeAvailable(selectInfo.startStr, selectInfo.resource.id)
      ) {
        return;
      }
      if (this.isDateTimeInPast(selectInfo.startStr)) {
        return;
      }

      this.newAdd.start = moment(selectInfo.startStr).format();
      this.modalShow = true;
      this.$http.get(`admins/getMassage/${selectInfo.resource.id}`).then(
        res => {
          if (res.data) {
            this.massageList = res.data;

            const newMassageList = [];
            for (const item of this.massageList) {
              if (
                item.sectionsId &&
                newMassageList.find(
                  el => Number(el.id) == Number(item.sectionsId.id)
                )
              ) {
                const index = newMassageList.findIndex(
                  el => Number(el.id) == Number(item.sectionsId.id)
                );
                newMassageList[index].list.push({
                  ...item,
                  name: this.$getByLang(item.name)
                });
              } else {
                newMassageList.push({
                  ...item.sectionsId,
                  name: this.$getByLang(item.sectionsId.name),
                  list: [{ ...item, name: this.$getByLang(item.name) }]
                });
              }
            }

            this.newMassageList = newMassageList;

            if (this.massageList.length > 0) {
              this.newAdd.massageId =
                this.newAdd.massageId == null
                  ? this.massageList[0].id
                  : Number(this.newAdd.massageId);

              const one = this.massageList.find(
                el => Number(el.id) == Number(this.newAdd.massageId)
              );

              console.log("oneeeeeee", one);
              if (one) {
                this.pricesList = one.pricesList;

                // Check if the pre-selected priceId (from URL) exists in this therapist's price list
                const priceExists =
                  this.newAdd.pricesId != null &&
                  this.pricesList.some(
                    p => Number(p.id) === Number(this.newAdd.pricesId)
                  );

                if (this.newAdd.pricesId == null || priceExists) {
                  // pricesId is null → pick first, or it exists → keep it
                  this.newAdd.pricesId =
                    this.newAdd.pricesId == null
                      ? this.pricesList[0].id
                      : this.newAdd.pricesId;
                } else {
                  // pricesId was pre-set from URL but not available for this therapist
                  // Reset to first available price and notify the user
                  this.newAdd.pricesId = this.pricesList[0].id;
                  this.$swal.fire({
                    icon: "info",
                    title: this.$t("Error"),
                    text: this.$t(
                      "Selected price plan not available for this therapist"
                    ),
                    showConfirmButton: true
                  });
                }
              } else {
                // Massage type itself is not offered by this therapist
                this.modalShow = false;
                this.$swal.fire({
                  icon: "error",
                  title: this.$t("Error"),
                  text: this.$t(
                    "That therapist does not offer this massage type please choose another therapist or another massage type"
                  ),
                  showConfirmButton: true
                });
              }
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    nextAddToList() {
      this.addNewObject();

      setTimeout(() => {
        this.tabIndex++;
      }, 1500);
    },
    addNewObject() {
      const price = this.pricesList.find(el => el.id == this.newAdd.pricesId);
      const minutes = Number(price.minutes) + Number(price.stoptime);
      this.newAdd.end = moment(this.newAdd.start)
        .add(minutes, "minutes")
        .format();

      const massage = this.massageList.find(i => i.id == this.newAdd.massageId);

      // Check for conflicts with the entire time range
      if (
        this.checkIfTimeRangeAvailable(
          this.newAdd.start,
          this.newAdd.end,
          this.newAdd.adminsId
        )
      ) {
        return;
      }

      // استخدام اسم المسير المحفوظ من selectInfo
      const therapistName = this.newAdd.therapistName || "N/A";

      // حفظ تفاصيل الجلسة كاملة للعرض
      const appointmentDetails = {
        ...this.newAdd,
        therapistName: therapistName,
        massageName: this.$getByLang(massage.name),
        massageColor: massage.color,
        price: price.price,
        minutes: price.minutes,
        stoptime: price.stoptime,
        totalMinutes: minutes
      };

      this.calendarOptions.events.push({
        id: null,
        title: new Date(this.newAdd.start),
        start: new Date(this.newAdd.start),
        end: new Date(this.newAdd.end),
        resourceId: Number(this.newAdd.adminsId),
        allDay: false,
        backgroundColor: massage.color
      });

      this.bodyArray.push(this.newAdd);
      this.selectedAppointmentsDetails.push(appointmentDetails);
      this.modalShow = false;

      this.newAdd = {
        start: null,
        end: null,
        adminsId: null,
        massageId: null,
        pricesId: null,
        therapistName: null
      };
    },
    httpg() {
      return axios.create({
        baseURL: `https://eu-prod.oppwa.com/v1/`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer OGFjOWE0Y2E4MzgzNTA5YjAxODM4M2ZjMmE2MDExY2Z8cDhHTWhuWXFiWA==`
        }
      });
    },
    save() {
      this.$eventHub.$emit("showSpinner", true);

      if (this.body.paymentMethod != "online") {
        this.add(null);
      } else {
        let price = 0;
        for (const item of this.bodyArray) {
          const p = this.pricesList.find(
            el => Number(el.id) == Number(item.pricesId)
          );
          price = price + p.price;
        }

        this.httpg()
          .post(
            "checkouts",
            querystring.stringify({
              entityId: "8ac9a4ca8383509b018383fdcc5811ec",
              amount: String(price),
              currency: "EUR",
              paymentType: "DB"
            })
          )
          .then(res2 => {
            this.add(res2.data.id);
          });
      }
    },
    add(rid) {
      if (this.body.paymentMethod) {
        const array = [];

        const uuid = uuidv4();
        for (const item of this.bodyArray) {
          array.push({
            ...item,
            ...this.body,
            paymentCCID: rid,
            uuid,
            fromWhere: "website",
            fromWhereTime: moment().format("YYYY-MM-DD HH:mm"),
            fromWhereUser: this.body.usersId
          });
        }

        this.$http.post(`appointments`, array).then(
          res => {
            this.$eventHub.$emit("showSpinner", false);
            this.$swal.fire({
              icon: "success",
              title: this.$t("Success"),
              text:
                this.body.paymentMethod != "online"
                  ? this.$t("Success Done")
                  : this.$t("toBay"),
              showConfirmButton: false,
              timer: 1500
            });

            console.log("response", res.data);

            if (this.body.paymentMethod == "online") {
              // this.submit();
              this.$router.push("/Payment/" + rid);
            } else {
              this.$router.push("/");
              this.$socket.emit("send", {});
            }
          },
          err => {
            this.$eventHub.$emit("showSpinner", false);
            if (err.response.data.message.indexOf("giftsIdId") !== -1) {
              this.$swal.fire({
                icon: "error",
                title: this.$t("Error"),
                text: this.$t("That number does not exist"),
                showConfirmButton: false,
                timer: 1500
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: this.$t("Error"),
                text: this.$t("Something has gone wrong"),
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        );
      } else {
        this.$swal.fire({
          icon: "error",
          title: this.$t("Error"),
          text: this.$t("Fields must be filled out"),
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async loadFullCalendar() {
      if (!this.isFullCalendarLoaded) {
        this.fullCalendarComponent = () => import("@fullcalendar/vue");
        this.isFullCalendarLoaded = true;
      }
    },
    isMob() {
      var windowWidth = window.innerWidth;

      return windowWidth < 750;
    },
    getMassageName(massageId) {
      if (!massageId) return "N/A";
      const massage = this.massageList.find(m => m.id === massageId);
      return massage ? this.$getByLang(massage.name) : "N/A";
    },
    getPriceDetails(priceId) {
      if (!priceId) return null;
      return this.pricesList.find(p => p.id === priceId);
    },
    formatDate(dateString) {
      if (!dateString) return "N/A";
      return moment(dateString).format("DD/MM/YYYY");
    },
    formatTime(dateString) {
      if (!dateString) return "N/A";
      return moment(dateString).format("HH:mm");
    },
    removeAppointment(index) {
      // حذف من قائمة التفاصيل
      this.selectedAppointmentsDetails.splice(index, 1);
      // حذف من قائمة البيانات الأساسية
      this.bodyArray.splice(index, 1);

      // إعادة تحديث التقويم
      this.updateCalendarEvents();
    },
    updateCalendarEvents() {
      // إعادة بناء أحداث التقويم
      this.calendarOptions.events = this.calendarOptions.events.filter(
        event => event.id !== null
      );

      // إضافة الأحداث الجديدة
      for (const appointment of this.selectedAppointmentsDetails) {
        this.calendarOptions.events.push({
          id: null,
          title: new Date(appointment.start),
          start: new Date(appointment.start),
          end: new Date(appointment.end),
          resourceId: Number(appointment.adminsId),
          allDay: false,
          backgroundColor: appointment.massageColor
        });
      }
    }
  },
  created() {
    this.loadFullCalendar();

    const id = this.$route.params.id;

    if (id > 0) {
      this.newAdd.massageId = id;
      if (this.$route.query.priceId) {
        this.newAdd.pricesId = this.$route.query.priceId;
      }
    }
    this.$http.get(`admins`).then(res => {
      this.userList = res.data.data;
      this.day = moment().format("YYYY-MM-DD");
    });
    this.$http.post(`users/getProfile`, {}).then(res => {
      const user = res.data.data;

      this.body.usersId = user.id;
      this.body.email = user.email;
      this.body.phone = user.phone;
      this.body.sexType = user.sexType;
      this.body.fname = user.fname;
      this.body.lname = user.lname;
      this.body.address = user.address;
      this.body.zip = user.zip;
      this.body.city = user.city;
      this.body.country = user.country;
      this.$http
        .get("packages_users?usersId=" + user.id + "&ended=0")
        .then(res => {
          this.packagesUsersList = res.data.data;
        });

      this.$http
        .post("gifts/search?limit=100000000", {
          recieverphone: user.phone,
          ended: 0
        })
        .then(res => {
          this.giftsList = res.data.data.items;
        });
    });

    let massage = this.$t(
      "Für die Auswahl Ihres Wunschtermins bitte 2 Sekunden auf die gewünschte Uhrzeit drücken. Achten Sie bitte darauf,"
    );
    let massage2 =
      " " +
      this.$t("keine Lücken zwischen den Terminen zu lassen. Vielen Dank!");

    if (!this.isMob()) {
      massage = "";
    }

    this.$swal.fire({
      customClass: {
        actions: "custom-swal-actions"
      },
      title: this.$t("Bitte beachten"),
      html: "<p>" + massage + " " + massage2 + "</p>",
      showConfirmButton: true
    });

    // const user = JSON.parse(localStorage.userKB);
  },
  mounted() {
    this.$socket.on("resved", data => {
      this.onTime().then(() => {});
    });
  },

  watch: {
    day(val) {
      if (val) {
        this.getData();
      }
    },
    "newAdd.massageId"(val) {
      if (val) {
        const one = this.massageList.find(el => Number(el.id) == Number(val));
        if (one) {
          this.pricesList = one.pricesList;
          this.newAdd.pricesId = this.pricesList[0].id;
        }
      }
    }
  },
  head: {
    title: {
      inner: "Appointment"
    },
    // Meta tags
    meta: [
      { name: "application-name", content: "Kleopatra Massage & Beauty" },
      {
        name: "description",
        content: "Kleopatra Massage & Beauty"
      }, // id to replace intead of create element
      // ...
      // Twitter
      { name: "twitter:title", content: "Kleopatra Massage & Beauty" },
      // with shorthand
      {
        n: "twitter:description",
        c: "Kleopatra Massage & Beauty"
      },
      // ...
      // Google+ / Schema.org
      { itemprop: "name", content: "Kleopatra Massage & Beauty" },
      { itemprop: "description", content: "Kleopatra Massage & Beauty" },
      // ...
      // Facebook / Open Graph
      // { property: 'fb:app_id', content: '123456789' },
      { property: "og:title", content: "Kleopatra Massage & Beauty" },
      // with shorthand
      {
        p: "og:image",
        c: "https://kleopatramassage-beauty.com/image/logo.png"
      }
      // ...
    ]
  }
};
</script>

<style>
.custom-swal-actions {
  margin: 0 !important;
}
.custom-swal-actions button,
.custom-actions-button {
  background-color: #af002d !important;
  border-color: #af002d !important;
}
@media (max-width: 767.98px) {
  .fc .fc-view-harness {
    height: 856.296px !important;
  }
}

.fc .fc-scrollgrid-section table {
  width: 100% !important;
  /* height: 825px !important; */
}

.fc-scrollgrid-section-body .fc-scrollgrid-section table {
  width: 100% !important;
  /* height: 856.296px !important; */
}

.asa {
  font-weight: 700;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.5);
}

tr > td[data-time="00:00:00"],
tr > td[data-time="01:00:00"],
tr > td[data-time="02:00:00"],
tr > td[data-time="03:00:00"],
tr > td[data-time="04:00:00"],
tr > td[data-time="05:00:00"],
tr > td[data-time="06:00:00"],
tr > td[data-time="07:00:00"],
tr > td[data-time="08:00:00"],
tr > td[data-time="09:00:00"],
tr > td[data-time="10:00:00"],
tr > td[data-time="11:00:00"],
tr > td[data-time="12:00:00"],
tr > td[data-time="13:00:00"],
tr > td[data-time="14:00:00"],
tr > td[data-time="15:00:00"],
tr > td[data-time="16:00:00"],
tr > td[data-time="17:00:00"],
tr > td[data-time="18:00:00"],
tr > td[data-time="19:00:00"],
tr > td[data-time="20:00:00"],
tr > td[data-time="21:00:00"],
tr > td[data-time="22:00:00"],
tr > td[data-time="23:00:00"] {
  border-top: 1px solid rgb(0, 0, 0) !important;
}

tr > td[data-time="00:30:00"],
tr > td[data-time="01:30:00"],
tr > td[data-time="02:30:00"],
tr > td[data-time="03:30:00"],
tr > td[data-time="04:30:00"],
tr > td[data-time="05:30:00"],
tr > td[data-time="06:30:00"],
tr > td[data-time="07:30:00"],
tr > td[data-time="08:30:00"],
tr > td[data-time="09:30:00"],
tr > td[data-time="10:30:00"],
tr > td[data-time="11:30:00"],
tr > td[data-time="12:30:00"],
tr > td[data-time="13:30:00"],
tr > td[data-time="14:30:00"],
tr > td[data-time="15:30:00"],
tr > td[data-time="16:30:00"],
tr > td[data-time="17:30:00"],
tr > td[data-time="18:30:00"],
tr > td[data-time="19:30:00"],
tr > td[data-time="20:30:00"],
tr > td[data-time="21:30:00"],
tr > td[data-time="22:30:00"],
tr > td[data-time="23:30:00"] {
  border-top: 1px dotted rgb(0, 0, 0) !important;
}

tr > td[data-time="00:15:00"] div,
tr > td[data-time="00:30:00"] div,
tr > td[data-time="00:45:00"] div,
tr > td[data-time="01:15:00"] div,
tr > td[data-time="01:30:00"] div,
tr > td[data-time="01:45:00"] div,
tr > td[data-time="02:15:00"] div,
tr > td[data-time="02:30:00"] div,
tr > td[data-time="02:45:00"] div,
tr > td[data-time="03:15:00"] div,
tr > td[data-time="03:30:00"] div,
tr > td[data-time="03:45:00"] div,
tr > td[data-time="04:15:00"] div,
tr > td[data-time="04:30:00"] div,
tr > td[data-time="04:45:00"] div,
tr > td[data-time="05:15:00"] div,
tr > td[data-time="05:30:00"] div,
tr > td[data-time="05:45:00"] div,
tr > td[data-time="06:15:00"] div,
tr > td[data-time="06:30:00"] div,
tr > td[data-time="06:45:00"] div,
tr > td[data-time="07:15:00"] div,
tr > td[data-time="07:30:00"] div,
tr > td[data-time="07:45:00"] div,
tr > td[data-time="08:15:00"] div,
tr > td[data-time="08:30:00"] div,
tr > td[data-time="08:45:00"] div,
tr > td[data-time="09:15:00"] div,
tr > td[data-time="09:30:00"] div,
tr > td[data-time="09:45:00"] div,
tr > td[data-time="10:15:00"] div,
tr > td[data-time="10:30:00"] div,
tr > td[data-time="10:45:00"] div,
tr > td[data-time="11:15:00"] div,
tr > td[data-time="11:30:00"] div,
tr > td[data-time="11:45:00"] div,
tr > td[data-time="12:15:00"] div,
tr > td[data-time="12:30:00"] div,
tr > td[data-time="12:45:00"] div,
tr > td[data-time="13:15:00"] div,
tr > td[data-time="13:30:00"] div,
tr > td[data-time="13:45:00"] div,
tr > td[data-time="14:15:00"] div,
tr > td[data-time="14:30:00"] div,
tr > td[data-time="14:45:00"] div,
tr > td[data-time="15:15:00"] div,
tr > td[data-time="15:30:00"] div,
tr > td[data-time="15:45:00"] div,
tr > td[data-time="16:15:00"] div,
tr > td[data-time="16:30:00"] div,
tr > td[data-time="16:45:00"] div,
tr > td[data-time="17:15:00"] div,
tr > td[data-time="17:30:00"] div,
tr > td[data-time="17:45:00"] div,
tr > td[data-time="18:15:00"] div,
tr > td[data-time="18:30:00"] div,
tr > td[data-time="18:45:00"] div,
tr > td[data-time="19:15:00"] div,
tr > td[data-time="19:30:00"] div,
tr > td[data-time="19:45:00"] div,
tr > td[data-time="20:15:00"] div,
tr > td[data-time="20:30:00"] div,
tr > td[data-time="20:45:00"] div,
tr > td[data-time="21:15:00"] div,
tr > td[data-time="21:30:00"] div,
tr > td[data-time="21:45:00"] div,
tr > td[data-time="22:15:00"] div,
tr > td[data-time="22:30:00"] div,
tr > td[data-time="22:45:00"] div,
tr
  > td[data-time="23:15:00"]
  div
  tr
  > td[data-time="23:30:00"]
  div
  tr
  > td[data-time="23:45:00"]
  div {
  display: none;
}

.fc.fc-theme-standard .fc-view-harness td {
  border-right: 2px solid #000;
}

/* تنسيق عرض تفاصيل الحجوزات */
.selected-appointments {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

.selected-appointments h4 {
  color: #f26838;
  font-weight: bold;
}

.selected-appointments .card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.selected-appointments .card-body {
  padding: 15px;
}

.selected-appointments .card-title {
  color: #f26838;
  font-weight: bold;
  margin-bottom: 10px;
}

.selected-appointments .card-text {
  margin-bottom: 8px;
  font-size: 14px;
}

.selected-appointments .card-text strong {
  color: #495057;
  font-weight: 600;
}

.selected-appointments .btn-outline-danger {
  border-color: #dc3545;
  color: #dc3545;
  font-size: 12px;
  padding: 4px 8px;
}

.selected-appointments .btn-outline-danger:hover {
  background-color: #dc3545;
  color: white;
}

/* تنسيق الجدول للويب */
.desktop-view .table {
  margin-bottom: 0;
}

.desktop-view .table th {
  background-color: #f26838 !important;
  color: white;
  border: none;
  font-weight: 600;
  padding: 12px 8px;
  text-align: center;
}

.desktop-view .table td {
  padding: 12px 8px;
  text-align: center;
  vertical-align: middle;
  border-color: #dee2e6;
}

.desktop-view .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(242, 104, 56, 0.05);
}

.desktop-view .table-hover tbody tr:hover {
  background-color: rgba(242, 104, 56, 0.1);
}

.desktop-view .btn-outline-danger {
  padding: 4px 8px;
  font-size: 12px;
}

/* تنسيق الموبايل */
.mobile-view .card {
  border-left: 4px solid #f26838;
}

.mobile-view .card-title {
  color: #f26838;
  font-weight: bold;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}

/* تحسينات إضافية للاستجابة */
@media (max-width: 767.98px) {
  .selected-appointments {
    padding: 15px;
  }

  .selected-appointments h4 {
    font-size: 1.2rem;
    margin-bottom: 15px;
  }
}

@media (min-width: 768px) {
  .selected-appointments {
    padding: 25px;
  }

  .desktop-view .table-responsive {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}
</style>
